var phone = "https://shopfront-cdn.tekoapis.com/static/82e24372ab515af4.svg";

export { phone as default };
